import { generateSpectrum } from 'spectrum-generator';
import { convertWidthToPPM } from './util/convertWidthToPPM';
export function peaksToXY(peaks, options) {
    const { from, to, nbPoints = 1024, shape, frequency } = options;
    return generateSpectrum(convertWidthToPPM(peaks, frequency), {
        generator: {
            from,
            to,
            nbPoints,
            shape,
        },
    });
}
//# sourceMappingURL=peaksToXY.js.map